type Props = {
  accountKind: "school" | "external";
  planCode: string | null;
  ownedBoardsCount: number;
  maxBoardsLimit: number;
  onUpgrade?: () => void;
  upgradeBusy?: boolean;
};

export function CabinetLimitBanner({
  accountKind,
  planCode,
  ownedBoardsCount,
  maxBoardsLimit,
  onUpgrade,
  upgradeBusy,
}: Props) {
  if (accountKind === "school") return null;
  if (maxBoardsLimit < 0) return null;
  if (ownedBoardsCount < maxBoardsLimit) return null;

  const code = (planCode ?? "free").toUpperCase();

  return (
    <div className="wb-cabinet-limit-banner" role="status">
      <p className="wb-cabinet-limit-banner__text">
        <strong>Лимит тарифа {code}</strong>
        <span>
          — у вас {ownedBoardsCount} из {maxBoardsLimit} досок. Удалите лишние или повысьте
          тариф.
        </span>
      </p>
      {onUpgrade ? (
        <button
          type="button"
          className="wb-cabinet-limit-banner__btn"
          disabled={upgradeBusy || planCode === "pro" || planCode === "business"}
          onClick={onUpgrade}
        >
          {upgradeBusy ? "…" : "Перейти на Pro"}
        </button>
      ) : null}
    </div>
  );
}
